module.exports = __webpack_public_path__ + "img/news3-4.fcf05bbe.png";